module.exports = __webpack_public_path__ + "a57e99ad019a426badfc13f43f42402d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-25.png
// module id = 3185
// module chunks = 0